import React from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import EscolherPlanos from './components/EscolherPlano';
import Formulario from './components/Formulario';
import '../../../assets/scss/incluirpropostapf.scss';
import axios from 'axios';
import configBase from '../../../configBase';
import {verificaCache} from '../../../verificaCache';

import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';



class IncluirPropostaPF extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      showForm: false,

      errorRequest: false,
      msgErrorRequest: "",
    };

  }

  componentDidMount() {
    verificaCache(function (vc) {
      if (vc.erro === false)
        this.getSalesman();
      else
        this.setError(vc.mensagem);
    }.bind(this));
  }

  showFormFn() {
    let state = this.state;
    state.showForm = true;
    this.setState(state);
  }

  getSalesman() {
    // Pega características do salesman do vendedor
    let user = localStorage.getItem("planos_u");

    if (localStorage.getItem("planos_y") === 'SALESMAN') {
      axios.get(configBase.api + 'Salesmans?filter={"where":{"userId":"'+user+'"}}&access_token='+localStorage.getItem('planos_t'))
      .then((result) => {
        localStorage.setItem("planos_sl", result.data[0].id);
      })
      .catch(function () {
        let state = this.state;
        state.disabledOption = false;
        this.setError('Problema encontrado ao buscar dados do vendedor');
      }.bind(this));
    }

  }

  setError(msg) {
    let state = this.state;
    state.errorRequest = true;
    state.msgErrorRequest = msg;
    this.setState(state);
  }

  errorClose() {
    let state = this.state;
    state.errorRequest = false;
    state.msgErrorRequest = '';
    this.setState(state);
  }




  render() {

    return (
      <div id="incluirPropostaPf">
        {
          this.state.showForm === true ? (
        <Formulario history={this.props.history} />
          ) : (
        <EscolherPlanos showFormFn={this.showFormFn.bind(this)} />
          )
        }

        <Snackbar open={this.state.errorRequest} autoHideDuration={5000} onClose={this.errorClose.bind(this)}>
          <MuiAlert className="snackbarStyle" onClose={this.errorClose.bind(this)} severity="error" variant="filled" elevation={6}>
            {this.state.msgErrorRequest}
          </MuiAlert>
        </Snackbar>
      </div>
    );

  }

}

IncluirPropostaPF.propTypes = {
  history: PropTypes.object
};

export default withRouter(IncluirPropostaPF);